<div class="my-card">
  <div class="my-card__barcode">
    <div>
      <air-barcode
        *ngIf="currentUser?.cardNumber && barcodeWidth && barcodeHeight"
        [value]="ean13CardNumber"
        [type]="barcodeType.ean13"
        [width]="barcodeWidth"
        [height]="barcodeHeight"
      ></air-barcode>
    </div>
  </div>
  <div class="my-card__number">
    <span class="my-card__number--label">{{ "general.label.airmiles_website" | translate }}</span>
    <span class="my-card__number--number">{{ currentUser?.cardNumber }}</span>
  </div>
</div>
